import { useStateSelector } from '../store/selectors';
import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { USER_ROLES } from '../utils/constants';

export const useCurrentMarketplaceParty = (): TimelineParty => {
    const summary = useStateSelector((s) => s.userSummary.summary);

    if (summary?.isMarketplaceBuyer) {
        return TimelineParty.Buyer;
    }
    if (summary?.roleId === USER_ROLES.ADMIN) {
        return TimelineParty.VetValue;
    }
    if (summary?.isMarketplaceBroker) {
        return TimelineParty.Broker;
    }
    return TimelineParty.Seller;
};
